import type { PostMetadata } from "@/lib/PostMetadata"
import { Link } from "next-view-transitions"

interface PostListProps extends PostMetadata {
	page: number
}

const PostList = (props: PostListProps) => {
	return (
		<Link href={`/posts/${props.slug}?page=${props.page}`} key={props.slug} title={props.slug}>
			<div className="font-jxzk flex flex-col space-y-[0.5]  mb-3 md:mb-5 duration-100">
				<p className=" text-sm md:text-lg xl:text-xl flex flex-nowrap truncate gap-2">
					{props.title}
					<span className="text-xs text-neutral-500 ">
						{props.date}
					</span>
				</p>
			</div>
		</Link>
	)
}
export default PostList
